export const getCurrentPhoneIndicator = (language: string): string => {
  switch (language) {
    case 'fr':
      return '+33'
    case 'es':
      return '+34'
    case 'de':
      return '+49'
    case 'it':
      return '+39'
    case 'pt':
      return '+351'
    default:
      return '+33'
  }
}
